module.exports = __webpack_public_path__ + "img/app_value.19832120.svg";